import React, { useState } from "react";
import { Typography } from "@mui/material";
import Styles from "./ActivityComponent.module.css";

import CalendarIcon from "../../../assets/SVGs/calender_icon.svg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface CalendarEvent {
  dateRange: string;
  title: string;
  description: string;
}

export default function CalenderActivity() {
  const [selectedMonth, setSelectedMonth] = useState<number>(dayjs().month()); // Default: Current Month

  const calendarEvents: CalendarEvent[] = [
    { dateRange: "10 Feb to 12 Feb", title: "Canada Road Show", description: "STAR Global Excellence Program Launch." },
    { dateRange: "14 Feb to 15 Feb", title: "SAZ Pilot", description: "STAR Global Excellence Program Launch." },
    { dateRange: "17 Feb to 18 Feb", title: "Brazil Road Show", description: "STAR Global Excellence Program Launch." },
    { dateRange: "19 Feb to 20 Feb", title: "Argentina Road Show", description: "" },
    { dateRange: "24 Feb to 26 Feb", title: "Mexico Road Show", description: "" },
    { dateRange: "4 Mar to 6 Mar", title: "China Road Show", description: "" },
    { dateRange: "10 Mar to 12 Mar", title: "India Road Show", description: "" },
    { dateRange: "01 Mar to 31 Mar", title: "Portal Mockup", description: "Employees can work with the portal & join the weekly helpdesk to share feedback & portal NPS " },
    { dateRange: "01 Apr to 11 Apr", title: "Evidence upload RTR, OTC, PTP", description: "Employees to update evidence in the STAR portal" },
    { dateRange: "14 Apr to 18 Apr", title: "Evidence upload  of People", description: "Employees to update evidence in the STAR portal" },
    { dateRange: "21 Apr to 30 Apr", title: "Evidence upload  of other functions", description: "Employees to update evidence in the STAR portal" },
    { dateRange: "02 May to 15 May", title: "Self Assessment", description: "Self assessment to be done by admins in self assessment tool" },
    { dateRange: "30 Jun", title: "Results", description: "Results to be declared by the global team" },
  
  ];

  
  const monthMapping: Record<string, number> = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
  };

  // Extract month from event date range
  const getMonthFromEvent = (dateRange: string): number => {
    const monthAbbr = dateRange.split(" ")[1]; // Extracts "Feb", "Mar", etc.
    return monthMapping[monthAbbr] ?? -1; // Ensure we return a valid number
  };

  // Filter events based on selected month
  const filteredEvents = calendarEvents.filter(
    (event) => getMonthFromEvent(event.dateRange) === selectedMonth
  );

  return (
    <div className={Styles.calenderMain}>
      <div className={Styles.calenderTitle}>
        <div>
          <img src={CalendarIcon} height={20} width={20} alt="Calendar" />
          <Typography sx={{
            fontWeight: '600', fontFamily: "Avant semibold" , fontSize:"18px",lineHeight:"1",
          }} variant="h6">Calendar</Typography>
        </div>

        {/* MUI Date Picker for Selecting Month */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
           className={Styles.monthcalender}
            label=""
            views={[ "month","year"]}
            minDate={dayjs("2025-01-01")}
            maxDate={dayjs("2025-12-31")}
            value={dayjs().month(selectedMonth)}
              format="MMM YYYY"
            onChange={(newValue: Dayjs | null) => {
              if (newValue) {
                setSelectedMonth(newValue.month());
              }
            }}
            slots={{
              openPickerIcon: ArrowDropDownIcon, // Replaces the calendar icon
            }}
           
          />
        </LocalizationProvider>
      </div>
      <hr />

      <div className={Styles.dateActivity}>
        {filteredEvents.length > 0 ? (
          filteredEvents.map((event, index) => (
            <div key={index}>
              <h4 className={Styles.calenderDate}>{event.dateRange}</h4>
              <div className={Styles.calenderActivityList}>
                <h5>{event.title}</h5>
                <p>{event.description}</p>
              </div>
            </div>
          ))
        ) : (
          <Typography variant="body1">No events found for this month.</Typography>
        )}
      </div>
    </div>
  );
}
